<template>
  <div class="aw ah share-main">
    <div class="box-expired aw ah" v-if="isFailure">
      <img src="./image/expired.png" alt="img" class="expired" />
    </div>
    <div class="box-password aw ah" v-else-if="passwordRequired">
      <div class="box">
        <div class="aw ah" style="position: relative">
          <el-form @submit.native.prevent="submit" class="form aw">
            <el-form-item>
              <template #label>
                <label style="color: #dddddd">请输入密码</label>
              </template>
              <div class="input">
                <el-input
                  v-model="password"
                  placeholder="密码"
                  autocomplete="off"
                  :type="isShowPassword ? 'text' : 'password'"
                  maxLength="12"
                >
                  <svg
                    class="show-password"
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    aria-hidden="true"
                    slot="suffix"
                    @click="isShowPassword = !isShowPassword"
                  >
                    <use
                      :xlink:href="
                        isShowPassword ? '#icon-browse' : '#icon-eye-close'
                      "
                    ></use>
                  </svg>
                </el-input>
                <el-button type="primary" @click="submit" class="btn">
                  确认
                </el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="aw ah" v-else-if="ok">
      <div
        class="bg-loading"
        :style="{ zIndex: loading ? 1 : -1 }"
        v-loading="loading"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0)"
      ></div>
      <iframe
        ref="iframe"
        class="frame aw ah"
        style="border: 0px"
        @load="loaded"
        :src="url"
      ></iframe>
    </div>
  </div>
</template>

<script>
import queryString from 'query-string'
import { axios } from '@/api/share.js'
import * as api from '@/api/share.js'
import _ from 'lodash'
export default {
  data () {
    return {
      // 准备完毕
      ok: false,
      // 分享Id
      shareId: undefined,
      loading: false,
      isShowPassword: false,
      // 链接是失效的
      isFailure: false,
      // 密码是必须的
      passwordRequired: false,
      password: '',
      model: {
        mapId: 0,
        version: 0
      }
    }
  },
  computed: {
    url () {
      const { shareId } = this
      const { mapId } = this.model
      return queryString.stringifyUrl({
        url: '/operatingPlatform/marker',
        query: {
          mapId,
          templateShare: shareId,
          template: true
        }
      })
    }
  },
  inject: ['refresh'],
  methods: {
    // 页面加载完成
    loaded () {
      setTimeout(() => {
        this.loading = false
      }, 1000)
    },
    async submit () {
      const { password, shareId: noncestr } = this
      const res = await api.passwordChecking({
        noncestr,
        password
      })
      if (res) {
        this.loading = true
        // 密码校验通过
        this.passwordRequired = false
        this.setAlreadyPassword(this.shareId)
        // 默认密码验证成功后，创建定时器
        this.createInterval()
      } else {
        this.$message.error('密码错误')
      }
    },
    /**
     * 是否已经输入密码
     */
    alreadyPassword (shareId) {
      return sessionStorage.getItem(`SHARE-${shareId}`)
    },
    setAlreadyPassword (shareId) {
      sessionStorage.setItem(`SHARE-${shareId}`, true)
    },
    clearAlreadyPassword (shareId) {
      sessionStorage.removeItem(`SHARE-${shareId}`)
    },
    setAlreadyMenus (shareId, menus) {
      sessionStorage.setItem(`SHARE-MENUS-${shareId}`, menus)
    },
    // 创建检测定时器
    createInterval () {
      // 创建定时器，检测更新
      let look = false
      setInterval(async () => {
        if (look) return
        const result = await api.templateEdateInspection(this.model.mapId, this.shareId)
        // 分享配置已更新，刷新页面
        if (result) {
          look = true
          this.clearAlreadyPassword(this.shareId)
          try {
            await this.$confirm('案例分享配置已改变，重新加载页面！', '提示', {
              confirmButtonText: '确定',
              type: 'warning',
              showCancelButton: false,
              closeOnClickModal: false,
              closeOnPressEscape: false
            })
          } finally {
            this.refresh()
          }
        }
      }, 15 * 1000)
    },
    forceLandscapeScreenHandle () {
      const html = document.getElementsByTagName('html')[0]
      const width = html.clientWidth
      const height = html.clientHeight
      const max = width > height ? width : height
      const min = width > height ? height : width
      this.$el.style.width = max + 'px'
      this.$el.style.height = min + 'px'
    }
  },
  async mounted () {
    const shareId = this.$route.params.id

    this.shareId = shareId

    // 开启分享标识
    axios.defaults.headers.templateshare = shareId
    const res = await api.getShareTemplate({ noncestr: shareId }).catch((r) => {
      // 链接已失效
      this.isFailure = true
      return Promise.reject(r)
    })
    const { enable, mapId } = res

    this.model.mapId = mapId

    if (!enable) {
      // 分享链接已失效
      this.isFailure = true
    } else {
      // 默认验证成功后，创建定时器
      this.createInterval()
    }
    // 图层管理默认可显示
    const temp = ['marker']
    /* ;[
      // 图层列表是否显示
      'layerListShow',
      // 路径规划
      'path',
      // 视点动画
      'viewpoint',
      // 标注数据
      'markSourceDataShow',
      // 标注附件
      'markSourceAttachmentShow'
    ].forEach((key) => {
      if (data[key]) {
        temp.push(key)
      }
    }) */
    this.setAlreadyMenus(shareId, temp)
    const reload = _.once(() => {
      window.location.reload()
    })
    window.addEventListener('message', ({ data: name }) => {
      if (name === 'shared:reload') {
        reload()
      }
    })
    window.addEventListener('resize', this.forceLandscapeScreenHandle.bind(this))
    this.forceLandscapeScreenHandle()
    this.ok = true
  },
  destroyed () {
    this.timer && clearInterval(this.timer)
    this.timer = undefined
  }
}
</script>
<style scoped lang="scss">
@media screen and (orientation: portrait) {
  /*竖屏样式*/
  .share-main {
    transform-origin: 0 0;
    transform: rotateZ(90deg) translateY(-100%);
  }
}
.box-expired {
  // display: flex;
  background: linear-gradient(0deg, #252527, #3d3d40);
  .expired {
    width: 543px;
    height: 417px;
    position: absolute;
    top: 15vh;
    left: calc(50% - 272px);
  }
}
.box-password {
  background-image: url('./image/password-bg2.png');
  background-size: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  > .box {
    width: 370px;
    height: 200px;
    background: linear-gradient(0deg, #252527, #5c5d61);
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.4);
    border-radius: 12px;
    position: absolute;
    top: 35vh;
    padding: 30px;
    &::before {
      content: '';
      position: absolute;
      width: 154px;
      height: 116px;
      right: 0px;
      top: -23px;
      background-image: url('./image/password-image.png');
    }
    &::after {
      content: '光耀元地图访问';
      position: absolute;
      top: 30px;
      left: 30px;
      font-size: 18px;
      font-weight: 400;
      color: #ffffff;
    }
    .form {
      position: absolute;
      bottom: 0px;
      .input {
        line-height: 32px;
        width: 100%;
        display: flex;
      }
      .btn {
        width: 60px;
        margin-left: 12px;
      }
    }
  }
}
.bg-loading {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url('./image/password-bg2.png');
  background-size: 100%;
}

.show-password {
  transform: translateY(2px);
}
</style>
